import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "label-container" }
const _hoisted_2 = { class: "radio-container" }
const _hoisted_3 = {
  key: 0,
  class: "validator-line"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "radio-icon-uni" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "radio-label-uni" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_Label, {
        name: $props.name,
        "is-required": $props.isRequired
      }, null, 8, ["name", "is-required"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      ($props.validator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.TUITranslateService.t("AIDesk.请填写必填项")), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.chooseItemList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "form-radio-box-mobile",
          key: index
        }, [
          _createElementVNode("div", {
            class: "radio-container-uni",
            onClick: ($event: any) => ($setup.clickItem(index))
          }, [
            _createElementVNode("div", _hoisted_5, [
              ($setup.isUniFrameWork)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("image", {
                      src: $setup.changeSelectedIcon(item),
                      alt: "",
                      style: {"width":"20px","height":"20px","vertical-align":"middle"}
                    }, null, 8, _hoisted_7)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: $setup.changeSelectedIcon(item),
                      alt: "",
                      style: {"width":"20px","height":"20px","vertical-align":"middle"}
                    }, null, 8, _hoisted_9)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item), 1)
          ], 8, _hoisted_4)
        ]))
      }), 128))
    ])
  ]))
}